import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Users, Mail, ExternalLink, Heart, Target, Handshake } from 'lucide-react';

const MemberBrother2BrotherPage = () => {
    return (
        <div className="space-y-6 max-w-4xl" data-testid="brother-2-brother-page">
            {/* Header */}
            <div className="text-center mb-8">
                <h1 className="text-3xl font-bold text-white font-['Playfair_Display'] flex items-center justify-center gap-3">
                    <Handshake className="w-8 h-8 text-[#C9A227]" />
                    Brother 2 Brother
                </h1>
                <p className="text-[#C9A227] text-lg font-medium italic mt-2">
                    Where accountability, brothership, and community meet!
                </p>
            </div>

            {/* Main Content Card */}
            <Card className="bg-[#2D3428] border-[#5A6350]">
                <CardContent className="p-6 space-y-8">
                    {/* What is B2B */}
                    <div className="space-y-3">
                        <h2 className="text-xl text-[#C9A227] font-semibold flex items-center gap-2">
                            <Users className="w-5 h-5" />
                            What is Brother 2 Brother?
                        </h2>
                        <p className="text-[#E0E0E0] leading-relaxed">
                            Brother 2 Brother (B2B) is a Recovery Room initiative that is all about facilitating healthy supportive relationships amongst Black men in the community. Under this initiative, you share the goal you're working towards and we'll pair you with another brother in the community for mutual support towards that goal. The intent is for you and your accountability partner to work together, devise a plan, and check in on each other routinely to see how things are going, encourage one another, and provide support towards your goal.
                        </p>
                    </div>

                    {/* Why Important */}
                    <div className="space-y-3">
                        <h2 className="text-xl text-[#C9A227] font-semibold flex items-center gap-2">
                            <Heart className="w-5 h-5" />
                            Why is Brother 2 Brother Important?
                        </h2>
                        <p className="text-[#E0E0E0] leading-relaxed">
                            Far too often Black men are conditioned to see each other as competition vs sources of support and fellowship. One of our main goals with the Recovery Room is to dismantle that conditioning in an effort to strengthen our community.
                        </p>
                    </div>

                    {/* What happens after sign up */}
                    <div className="space-y-3">
                        <h2 className="text-xl text-[#C9A227] font-semibold flex items-center gap-2">
                            <Target className="w-5 h-5" />
                            What happens after I sign up?
                        </h2>
                        <p className="text-[#E0E0E0] leading-relaxed">
                            Within 14 days, you'll receive a follow up on the status of your pair. The goal is to group like minded brothers together that are working towards similar goals/interests. Applications for this program are accepted on a rolling basis. Depending on the number of those enrolled and the types of goals indicated, some "pairs" may be small groups of three but no more than four people to maintain the closeness of the partners. Once we have a match for you, your contact information will be shared via email along with a brief introduction. This is voluntary, but we will ask that pairs share updates with the larger group on how things are going! Our initiative lead, Lance, will follow up from time to time to check in.
                        </p>
                    </div>

                    {/* What happens after goal */}
                    <div className="space-y-3">
                        <h2 className="text-xl text-[#C9A227] font-semibold flex items-center gap-2">
                            <Handshake className="w-5 h-5" />
                            What happens after I reach my goal?
                        </h2>
                        <p className="text-[#E0E0E0] leading-relaxed">
                            This is exactly what we want to see! After your goal has been reached, stay in contact with your accountability partner and seek other ways to collaborate and support one another. Make it a practice and encourage others within your immediate community to do the same.
                        </p>
                    </div>
                </CardContent>
            </Card>

            {/* Contact Card */}
            <Card className="bg-[#3D4435] border-[#5A6350]">
                <CardContent className="p-6">
                    <div className="flex items-center gap-3">
                        <Mail className="w-6 h-6 text-[#C9A227]" />
                        <div>
                            <p className="text-white font-medium">Have questions, comments, or concerns?</p>
                            <p className="text-[#A0A0A0]">
                                Contact our initiative lead, Lance, at{' '}
                                <a 
                                    href="mailto:lance25st@gmail.com" 
                                    className="text-[#C9A227] hover:underline"
                                >
                                    lance25st@gmail.com
                                </a>
                            </p>
                        </div>
                    </div>
                </CardContent>
            </Card>

            {/* Sign Up Button */}
            <div className="flex justify-center pt-4">
                <a
                    href="https://docs.google.com/forms/d/1ts7zeXMoNS3W8dA8_NpjVmQCwcYsXmzfLiiJ1KRdseU/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-[#C9A227] hover:bg-[#B8922A] text-[#3D4435] font-bold px-10 py-4 rounded-xl transition-all text-lg shadow-lg hover:shadow-xl"
                    data-testid="b2b-signup-btn"
                >
                    <Handshake className="w-6 h-6" />
                    Sign Up for Brother 2 Brother
                    <ExternalLink className="w-5 h-5" />
                </a>
            </div>
        </div>
    );
};

export default MemberBrother2BrotherPage;
